<!-- @if(featureDynamicService.donationTeaser && breakpointService.breakpoint() !== 'DESKTOP'){
<app-donation></app-donation>
} -->
@if(showCarouselOutlet()) {
<div class="carouselOutlet">
    <router-outlet name="carousel"></router-outlet>
</div>
}


<div class="app-content-backdrop">
    <div class="app-content">
        <!-- @defer (on immediate;) { -->
        @if(showMenuBar()) {
        <app-menu-bar></app-menu-bar>
        }
        <!-- } @placeholder {
        <div></div>
        } -->
        <div class="app-row">
            <!-- flexible space, on DESKTOP only-->
            <div class="ystmLeftContent"></div>

            <div class="ystmMainContent">
                <router-outlet></router-outlet>
            </div>
            <!-- flexible space, on DESKTOP only-->
            <div class="ystmLeftContent"></div>

            <!-- right side information panel on  DESKTOP only-->
            @if(showApplicationInfoPanel()) {
            <div class="app-info-panel">
                <!-- @defer (on viewport;) { -->
                <app-application-info-panel />
                <!-- } @placeholder {
                <div></div>
                } -->
            </div>
            }
        </div>
    </div>

</div>